// ═══════════════════════════════════════════════
//   FOOD DEFENDER — shooter minigame
// ═══════════════════════════════════════════════
//
// Objective:   Defend the konbini by auto-shooting falling expired food
//              before it reaches the floor.
// Type:        aim-shoot
// Description: Mouse/touch moves the worker; bullets auto-fire upward.
//              Each enemy that lands costs 1 HP (GAME_SHOOTER.hp total).
//              Spawn rate and enemy speed ramp every GAME_SHOOTER.tierEvery
//              kills; run ends when HP hits 0. Reward scales with kills.
// Tunables:    GAME_SHOOTER in data.js.

const {canvas, ctx, claimGameReward, addCleanup, showGameOver, setHP, loseHP} = window;

const SHOOT_FOOD = ['🍙', '🍜', '🍵', '🍡', '🧃', '🍫', '🥟', '🍱', '🍬', '🍢', '🥡', '🍘'];

// Shooter state
let shootPlayerX = 0;          // player center X (follows mouse)
window.shootBullets   = [];    // [{x,y,hit}]
window.shootEnemies   = [];    // [{x,y,emoji,speed,dead}]
window.shootParticles = [];    // [{x,y,vx,vy,alpha,emoji,scale}]
let shootFireCtr     = 0;      // frames since last bullet
let shootSpawnCtr    = 0;      // frames since last enemy spawn
let shootSpawnEvery  = 0;      // frames between spawns (ramps with score)
let shootEnemySpd    = 0;      // base enemy fall speed (ramps with score)
let shootHitFlash    = 0;      // frames of red screen flash after hit
let shootInvincible  = 0;      // invincibility frames after taking damage

// Layout constants — visual sizing only
const SH_PW = 52, SH_PH = 48;  // player width/height
const SH_BW = 7,  SH_BH = 16;  // bullet width/height
const SH_EW = 44, SH_EH = 44;  // enemy bounding box

function startShooter() {
    const CFG = window.GAME_SHOOTER;
    window.gameRunning = true;
    window.gameScore = 0;
    shootPlayerX = canvas.width / 2;
    window.shootBullets   = [];
    window.shootEnemies   = [];
    window.shootParticles = [];
    shootFireCtr    = 0;
    shootSpawnCtr   = 0;
    shootSpawnEvery = CFG.spawnEveryInit;
    shootEnemySpd   = CFG.enemySpdInit;
    shootHitFlash   = 0;
    shootInvincible = 0;
    setHP(CFG.hp, CFG.hp);
    document.getElementById('mg-score').textContent = '0';

    // No timerInterval — game ends by HP reaching 0
    window.gameInterval = setInterval(shooterLoop, 16);
    addCleanup(() => clearInterval(window.gameInterval));

    canvas.addEventListener('mousemove', shooterMouse);
    canvas.addEventListener('touchmove', shooterTouch, {passive: false});
    addCleanup(() => canvas.removeEventListener('mousemove', shooterMouse));
    addCleanup(() => canvas.removeEventListener('touchmove', shooterTouch));
    addCleanup(() => {
        window.shootBullets = [];
        window.shootEnemies = [];
        window.shootParticles = [];
    });
}

function shooterMouse(e) {
    shootPlayerX = canvasPos(e).x;
}

function shooterTouch(e) {
    e.preventDefault();
    shootPlayerX = canvasPos(e).x;
}

function shooterLoop() {
    if (!window.gameRunning) return;
    const CFG = window.GAME_SHOOTER;
    const W = canvas.width, H = canvas.height;
    const px = Math.max(SH_PW / 2, Math.min(W - SH_PW / 2, shootPlayerX));
    const pTop = H - SH_PH - 10; // player top Y

    // ── Difficulty scales with kills (score) ──
    const tier = Math.floor(window.gameScore / CFG.tierEvery);
    shootEnemySpd   = CFG.enemySpdInit + tier * CFG.enemySpdStep;
    shootSpawnEvery = Math.max(CFG.spawnEveryMin, CFG.spawnEveryInit - tier * CFG.spawnEveryStep);
    const doubleChance = Math.min(CFG.doubleChanceMax, tier * CFG.doubleChanceStep);

    // ── Invincibility countdown ──
    if (shootInvincible > 0) shootInvincible--;
    if (shootHitFlash > 0) shootHitFlash--;

    // ── Auto-fire ──
    shootFireCtr++;
    if (shootFireCtr >= CFG.fireEveryFrames) {
        shootFireCtr = 0;
        window.shootBullets.push({x: px, y: pTop - 2, hit: false});
        SFX.play('shoot');
    }

    // ── Spawn enemies ──
    shootSpawnCtr++;
    if (shootSpawnCtr >= shootSpawnEvery) {
        shootSpawnCtr = 0;
        const spd = shootEnemySpd * (0.72 + Math.random() * 0.56);
        window.shootEnemies.push({
            x: SH_EW / 2 + 14 + Math.random() * (W - SH_EW - 28),
            y: -SH_EH,
            emoji: SHOOT_FOOD[Math.floor(Math.random() * SHOOT_FOOD.length)],
            speed: spd, dead: false
        });
        if (Math.random() < doubleChance) {
            window.shootEnemies.push({
                x: SH_EW / 2 + 14 + Math.random() * (W - SH_EW - 28),
                y: -SH_EH - 55,
                emoji: SHOOT_FOOD[Math.floor(Math.random() * SHOOT_FOOD.length)],
                speed: spd * (0.8 + Math.random() * 0.4), dead: false
            });
        }
    }

    // ── Move bullets up ──
    for (const b of window.shootBullets) b.y -= 10;

    // ── Move enemies down ──
    for (const e of window.shootEnemies) {
        if (!e.dead) e.y += e.speed;
    }

    // ── Bullet ↔ enemy collision ──
    for (const b of window.shootBullets) {
        if (b.hit) continue;
        for (const e of window.shootEnemies) {
            if (e.dead) continue;
            if (Math.abs(b.x - e.x) < (SH_EW / 2 + SH_BW / 2) &&
                Math.abs(b.y - e.y) < (SH_EH / 2 + SH_BH / 2)) {
                b.hit = true;
                e.dead = true;
                SFX.play('hit');
                window.gameScore++;
                document.getElementById('mg-score').textContent = window.gameScore;
                for (let i = 0; i < 6; i++) {
                    window.shootParticles.push({
                        x: e.x, y: e.y,
                        vx: (Math.random() - 0.5) * 5,
                        vy: -Math.random() * 5 - 1,
                        alpha: 1, emoji: e.emoji,
                        scale: 0.8 + Math.random() * 0.6
                    });
                }
                break;
            }
        }
    }

    // ── Enemy reaches floor → damage player ──
    for (const e of window.shootEnemies) {
        if (e.dead) continue;
        if (e.y > H + 4) {
            e.dead = true;
            if (shootInvincible <= 0) {
                const remaining = loseHP(1);
                SFX.play('damage');
                shootHitFlash = 18;
                shootInvincible = CFG.invincibleFrames;
                for (let i = 0; i < 5; i++) {
                    window.shootParticles.push({
                        x: e.x, y: H - 14,
                        vx: (Math.random() - 0.5) * 6,
                        vy: -Math.random() * 6 - 2,
                        alpha: 1, emoji: '💥', scale: 0.9 + Math.random() * 0.4
                    });
                }
                if (remaining <= 0) {
                    endShooter();
                    return;
                }
            }
        }
    }

    // ── Update particles ──
    for (const p of window.shootParticles) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.22;
        p.alpha -= 0.045;
        p.scale = Math.max(0.1, p.scale - 0.018);
    }

    // ── Prune ──
    window.shootBullets   = window.shootBullets.filter(b => !b.hit && b.y > -30);
    window.shootEnemies   = window.shootEnemies.filter(e => !e.dead);
    window.shootParticles = window.shootParticles.filter(p => p.alpha > 0.05);

    // ════════════════════ DRAW ════════════════════

    // ── Sky: cute pink-to-dark gradient ──
    const bgGrad = ctx.createLinearGradient(0, 0, 0, H);
    bgGrad.addColorStop(0, '#08000e');
    bgGrad.addColorStop(0.35, '#260028');
    bgGrad.addColorStop(0.68, '#580040');
    bgGrad.addColorStop(1, '#8b0058');
    ctx.fillStyle = bgGrad;
    ctx.fillRect(0, 0, W, H);

    // Soft pink nebula clouds (static, decorative)
    const time = Date.now() / 8000;
    ctx.globalAlpha = 0.07;
    for (let i = 0; i < 3; i++) {
        const nx = (i * W / 3 + 60 + Math.sin(time + i) * 18) % W;
        const ny = 40 + i * 55;
        const ng = ctx.createRadialGradient(nx, ny, 0, nx, ny, 70 + i * 20);
        ng.addColorStop(0, '#f72585');
        ng.addColorStop(1, 'transparent');
        ctx.fillStyle = ng;
        ctx.fillRect(nx - 90, ny - 60, 180, 120);
    }
    ctx.globalAlpha = 1;

    // Star field
    for (let i = 0; i < 28; i++) {
        const sx = (i * 137 + 61) % W, sy = (i * 83 + 19) % (H * 0.62);
        const pink = (i % 4 === 0);
        ctx.fillStyle = pink ? 'rgba(247,37,133,0.7)' : 'rgba(255,255,255,0.55)';
        const sr = pink ? 1.8 : ((i % 3 === 0) ? 1.5 : 1);
        ctx.beginPath();
        ctx.arc(sx, sy, sr, 0, Math.PI * 2);
        ctx.fill();
    }

    // Subtle shelf lines
    ctx.strokeStyle = 'rgba(247,37,133,0.07)';
    ctx.lineWidth = 1;
    for (let y = 60; y < H - 70; y += 55) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(W, y);
        ctx.stroke();
    }

    // ── Floor ──
    ctx.fillStyle = '#f72585';
    ctx.fillRect(0, H - 8, W, 8);
    ctx.fillStyle = 'rgba(0,0,0,0.3)';
    ctx.fillRect(0, H - 9, W, 2);

    // ── Enemies ──
    for (const e of window.shootEnemies) {
        const danger = e.y > H * 0.62;
        if (danger) {
            ctx.shadowColor = '#f72585';
            ctx.shadowBlur = 10 + Math.sin(Date.now() / 110) * 4;
        }
        ctx.font = `${SH_EW}px serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(e.emoji, e.x, e.y);
        ctx.shadowBlur = 0;
    }

    // ── Bullets ──
    for (const b of window.shootBullets) {
        ctx.shadowColor = '#f5c842';
        ctx.shadowBlur = 8;
        ctx.fillStyle = '#f5c842';
        ctx.fillRect(b.x - SH_BW / 2, b.y - SH_BH / 2, SH_BW, SH_BH);
        ctx.fillStyle = '#f72585';
        ctx.fillRect(b.x - SH_BW / 2 + 1, b.y - SH_BH / 2 + 1, SH_BW - 2, 4);
        ctx.shadowBlur = 0;
    }

    // ── Particles ──
    for (const p of window.shootParticles) {
        ctx.globalAlpha = p.alpha;
        ctx.font = `${Math.round(SH_EW * p.scale)}px serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(p.emoji, p.x, p.y);
    }
    ctx.globalAlpha = 1;

    // ── Red damage flash overlay ──
    if (shootHitFlash > 0) {
        ctx.fillStyle = `rgba(247,37,133,${(shootHitFlash / 18) * 0.32})`;
        ctx.fillRect(0, 0, W, H);
        if (shootInvincible > 0 && Math.floor(shootInvincible / 6) % 2 === 0) {
            ctx.font = '5px "Press Start 2P",monospace';
            ctx.fillStyle = 'rgba(255,255,255,0.5)';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'alphabetic';
            ctx.fillText('DEFEND THE KONBINI — SHOOT EXPIRED FOOD!', W / 2, H - 16);
            return;
        }
    }

    // ── Player ──
    const skipPlayer = shootInvincible > 0 && shootHitFlash <= 0 && Math.floor(shootInvincible / 6) % 2 === 0;
    if (!skipPlayer) shootDrawPlayer(px, pTop);

    // ── HUD label ──
    ctx.font = '5px "Press Start 2P",monospace';
    ctx.fillStyle = 'rgba(255,182,200,0.55)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillText('DEFEND THE KONBINI — SHOOT EXPIRED FOOD!', W / 2, H - 16);
}

function shootDrawPlayer(cx, ty) {
    // Gun barrel
    ctx.fillStyle = '#a8e063';
    ctx.strokeStyle = '#1a0010';
    ctx.lineWidth = 2;
    ctx.shadowColor = '#a8e063';
    ctx.shadowBlur = 6;
    ctx.beginPath();
    ctx.roundRect(cx - 4, ty - 20, 8, 22, 3);
    ctx.fill();
    ctx.stroke();
    ctx.shadowBlur = 0;
    // Body
    ctx.fillStyle = 'white';
    ctx.strokeStyle = '#f72585';
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.roundRect(cx - SH_PW / 2, ty, SH_PW, SH_PH, 6);
    ctx.fill();
    ctx.stroke();
    // Apron stripe
    ctx.fillStyle = '#f72585';
    ctx.fillRect(cx - SH_PW / 2 + 5, ty + SH_PH * 0.45, SH_PW - 10, SH_PH * 0.32);
    // Cap
    ctx.fillStyle = '#f72585';
    ctx.strokeStyle = '#1a0010';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.roundRect(cx - SH_PW / 2 + 5, ty - 15, SH_PW - 10, 17, 4);
    ctx.fill();
    ctx.stroke();
    ctx.fillStyle = '#1a0010';
    ctx.beginPath();
    ctx.roundRect(cx - SH_PW / 2 + 2, ty - 1, SH_PW - 4, 5, 2);
    ctx.fill();
    // Eyes
    ctx.fillStyle = '#1a0010';
    ctx.beginPath();
    ctx.arc(cx - 11, ty + SH_PH * 0.24, 3.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(cx + 11, ty + SH_PH * 0.24, 3.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'white';
    ctx.beginPath();
    ctx.arc(cx - 9.5, ty + SH_PH * 0.22, 1.2, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(cx + 12.5, ty + SH_PH * 0.22, 1.2, 0, Math.PI * 2);
    ctx.fill();
    // ♡ on apron
    ctx.font = '11px serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'white';
    ctx.fillText('♡', cx, ty + SH_PH * 0.63);
}

function endShooter() {
    const CFG = window.GAME_SHOOTER;
    SFX.play('gameover');
    window.gameRunning = false;
    if (window.gameScore >= CFG.nickThreshold) window.unlockNick('defender');
    const p = Math.min(CFG.rewardMax, Math.floor(window.gameScore * CFG.rewardMult));
    showGameOver(claimGameReward('shooter', window.gameScore, p));
}

window.startShooter = startShooter;
window.endShooter = endShooter;
window.shooterMouse = shooterMouse;
window.shooterTouch = shooterTouch;
